import { autoinject } from 'aurelia-dependency-injection';
import { EntityManager } from "aurelia-orm";
import { EntityService } from "../../data/service/entity-service";
import { ListItem } from "../../data/entities/list-item";
import { Item } from '../../data/entities/item';
import { EntityStatuses } from "../../core/enums";

@autoinject
export class ListItemDataService extends EntityService<ListItem> {

    constructor(entityManager: EntityManager) {
        super(ListItem, entityManager);
    }

    addListItem(parent: Item) {
        let newItem = this.getNew();
        newItem.itemId = parent.id;
        newItem.entityStatusId = EntityStatuses.Active;
        parent.listItems._add(newItem);
    }

}